import { Navbar } from "../material-old";
import { Searchbar } from "./Searchbar.tsx";
import NavbarProfile from "./NavbarProfile.tsx";
import { useAppSelector } from "../../redux/hooks.ts";

export function TopNavbar() {
  const { userInfo } = useAppSelector((state) => state.auth);

  if (!userInfo) return null;

  return (
    <Navbar className="z-50 mx-auto p-2 py-3 lg:pl-6 w-full min-w-full flex border border-gray-300 rounded-none sticky top-0 left-0 bg-white shadow-none">
      <div className="w-full mx-auto flex items-center justify-around text-blue-gray-900">
        <Searchbar />
        <NavbarProfile />
      </div>
    </Navbar>
  );
}
